import React from 'react';
import { AuthenticationConsumer } from '../../core/services/AuthenticationProvider';
import { Loader } from '../../core/components';

export const SilentRefreshRoute = () => {
    return (
        <AuthenticationConsumer>
            {({silentRefreshCallback}) => {
                !silentRefreshCallback || silentRefreshCallback();
                
                return <Loader main={true} opacity={1} />
            }}
        </AuthenticationConsumer>
    ) 
}